import { NotFoundView } from '@ui/components';
import { MobileHeader } from '@/ui/components/MobileHeader';

/**
 * NotFoundPage Component
 *
 * 404 Error page displayed when users navigate to a non-existent route.
 * Uses MobileHeader for navigation menu and NotFoundView for full-screen error content.
 *
 * Layout: Full-screen 404 view with menu at top, no container constraints.
 *
 * @example
 * ```tsx
 * // In router configuration:
 * <Route path="*" element={<NotFoundPage />} />
 * ```
 */
export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Menu at top */}
      <MobileHeader fixed={true} isAuthenticated={false} />

      {/* NotFoundView fills remaining space - edge-to-edge */}
      <div className="flex-1 flex">
        <NotFoundView />
      </div>
    </div>
  );
}
